module.exports = __webpack_public_path__ + "media/audio40.b5599909.mp3";